import config from './mapConfig';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';

mapboxgl.accessToken = config.accessToken;

// Creating mapbox and disabling interactions while map is zooming
export const mapBox = new mapboxgl.Map({
  container: 'map',
  style: config.style,
  center: config.center,
  zoom: config.zoom,
  attributionControl: false
}).addControl(new mapboxgl.AttributionControl({ compact: true }));

mapBox.scrollZoom.disable();

mapBox.on('load', () => {
  mapBox.getCanvas()?.setAttribute('tabindex', '-1');
});

mapBox.on('movestart', ({ originalEvent }) => {
  if (!originalEvent) {
    disableInteraction();
  }
});

mapBox.on('moveend', ({ originalEvent }) => {
  if (!originalEvent) {
    enableInteraction();
  }
});

// Adding zoom buttons to bottom right of map
export const nav = new mapboxgl.NavigationControl({ showCompass: false });
mapBox.addControl(nav, 'bottom-right');

// Creating geocoder
export const geocoder = new MapboxGeocoder({
  accessToken: mapboxgl.accessToken,
  mapboxgl: mapboxgl,
  flyTo: false,
  marker: false,
  countries: 'us',
  placeholder: 'Search by city, state, or zip code',
  proximity: {
    latitude: 37.532043792519644,
    longitude: -121.9826385613748
  },
  types: 'postcode, address, place, region',
  bbox: [-124.410607, 32.534231, -114.134458, 42.009659]
});

geocoder.addTo('#location-input-wrapper');

export function createMarker(branch, branches) {
  const { lat, lng } = branch.coords;

  const markerWrapper = document.createElement('div');
  markerWrapper.className = 'markerWrapper';
  markerWrapper.setAttribute('role', 'figure');
  const el = document.createElement('div');
  branch.marker = $(el);
  el.className = 'marker';

  // const delay = randomIntFromInterval(50, 300);
  // el.style.animationDelay = `${delay}ms`;

  el.addEventListener('click', e => {
    if (branches.current !== branch) {
      branches.markerClicked = true;
      branch.select(e);
    }
  });

  markerWrapper.appendChild(el);

  new mapboxgl.Marker(markerWrapper, {
    anchor: 'bottom'
  })
    .setLngLat([lng, lat])
    .addTo(mapBox);
}

// function randomIntFromInterval(min, max) {
//   // min and max included
//   return Math.floor(Math.random() * (max - min + 1) + min);
// }

function disableInteraction() {
  mapBox.scrollZoom.disable();
  mapBox.touchZoomRotate.disable();
  mapBox.dragPan.disable();
  mapBox.getCanvas().style.cursor = 'default';
}

function enableInteraction() {
  mapBox.touchZoomRotate.enable();
  mapBox.dragPan.enable();
  mapBox.getCanvas().style.cursor = null;
}
